import React, { Fragment } from 'react';
import styled from 'styled-components';
import Chip from '../chip';
import I10n from '../../features/i10n';
import Skeleton from '../skeleton';
import Button from '../../atoms/button';
import { SECONDARY_COLOR } from '../../color-constants';

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 1 0px;
`;

const SoftwareGroupTitle = styled.span`
  font-size: 30px;
  color: #000000;
  margin-bottom: 20px;
`;

const SoftwaresWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  @media (max-width: 800px) {
    flex-direction: column;
    margin-right: 0px;
  }
`;

const SoftwareTile = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  background-color: white;
  width: calc(50% - 20px);
  padding: 20px;
  margin-bottom: 10px;
  margin-right : 20px;
  min-width: 200px;
  border-radius: 8px;
  @media (max-width: 800px) {
    min-width: unset;
    flex: unset;
    width: auto;
    margin-right : 0px;

  }
`;

const SoftwareHeader = styled.div`
  display: flex;
`;

const SoftwareImage = styled.img`
  width: 100px;
  height: 100px;
  margin-right: 10px;
  margin-top: -10px;
`;

const SoftwareTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const SoftwareTitle = styled.span`
  font-size: 18px;
  color: rgba(0, 0, 0, 0.8);
  margin-bottom: 20px;
  font-weight: 700;
`;

const SoftwareDescription = styled.span`
  font-size: 16px;
  color: ${SECONDARY_COLOR};
  color : var(--se-primary, ${SECONDARY_COLOR});
  font-weight: 700;
`;

const SoftwareAdditionalInformation = styled.span`
  font-size: 16px;
  color: #626469;
  margin: 20px 0px;
  font-weight: 400;
`;

const ChooseSoftwareButtonWrapper = styled.div`
  flex: 1 1 0px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
`;

const FiltersRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 10px;
`;

const FilterLabel = styled.span`
  color:  #0F0F0F;
  font-size: 14px;
  font-weight: 400;
  margin-right: 5px;
`;

const ChipWrapper = styled.div`
  margin-right: 10px;
`;

const FiltersWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;

class SoftwareSelectionScreenContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedFilter: null,
    };
    this._isMounted = false;
  }

  componentDidMount = () => {
    this._isMounted = true;
  }

  componentWillUnmount = () => {
    this._isMounted = false;
  }

  updateStateIfMounted(state) {
    if (this._isMounted) {
      this.setState(state);
    }
  }

  renderSoftwareGroup = (group) => {
    return (
      <>
      <SoftwareGroupTitle>
        {I10n.getOrDefault(`screen.software_selection.categories.${group.key}.name`, group.name)}

      </SoftwareGroupTitle>
      <SoftwaresWrapper>
        {group.softwares.filter(software => {
          return this.state.selectedFilter == null || this.state.selectedFilter === software.key;
        }).map((software) => {
          return (
            <SoftwareTile key={software.key}>
              <SoftwareHeader>
                <SoftwareImage src={software.imageURL}></SoftwareImage>
                <SoftwareTitleWrapper>
                  <SoftwareTitle>{I10n.getOrDefault(`category.${software.key}.name`, software.name, 'data')}</SoftwareTitle>
                  <SoftwareDescription>{I10n.getOrDefault(`screen.software_selection.${software.key}.description`, software.description)}</SoftwareDescription>
                </SoftwareTitleWrapper>
              </SoftwareHeader>
              <SoftwareAdditionalInformation>
                {I10n.getOrDefault(`screen.software_selection.${software.key}.additional_information`, software.additionalInformation)}
              </SoftwareAdditionalInformation>
              <ChooseSoftwareButtonWrapper>
                <Button
                  importance="emphasized"
                  primary
                  disabled={this.props.isSaving}
                  onClick={() => {
                    this.props.setSoftwareSelection(software);
                  }}>{I10n.get('screen.software_selection.configure_licences')}</Button>
              </ChooseSoftwareButtonWrapper>
            </SoftwareTile>
          );
        })}
      </SoftwaresWrapper>
      </>
    );
  }

  renderFilters = () => {
    return (
      <FiltersRow>
        <FilterLabel>{I10n.get('screen.software_selection.filter_by')}</FilterLabel>
        <FiltersWrapper>
          {this.props.filters.map((filter, idx) => {
            return (<ChipWrapper key={idx}><Chip
              value= {I10n.getOrDefault(`screen.software_selection.filter.${filter.key}`, filter.name)}
              onClick={() => {
                if (this.state.selectedFilter === filter.softwareKey) {
                  this.updateStateIfMounted({selectedFilter: null});
                } else {
                  this.updateStateIfMounted({selectedFilter: filter.softwareKey});
                }
              }}
              selected={this.state.selectedFilter === filter.softwareKey}
            /></ChipWrapper>);
          })}
        </FiltersWrapper>
      </FiltersRow>
    );
  }

  render = () => {
    return (
      <ContentWrapper>
        {this.props.softwaresLoading ? <Skeleton nbCols={2} expand={true}></Skeleton> : this.props.softwareGroups.map((group, idx) => {
          return <Fragment key={idx}>
            {this.props.filters.length > 1 && this.renderFilters()}
            {this.renderSoftwareGroup(group)}
          </Fragment>
        })}
      </ContentWrapper>
    );
  }
}

export default SoftwareSelectionScreenContent;
